import { useIsRouteSegment } from '@shared/hooks';
import { Skeleton } from '@shared/ui';

import cls from './Dashboard.module.css';

export const DashboardProjectName = ({
    isLoading,
    projectName,
}: {
    isLoading: boolean;
    projectName: string;
}) => {
    const fromCrm = useIsRouteSegment('crm');

    if (fromCrm) return null;

    return isLoading ? (
        <Skeleton height={24} width={219} border="6px" classes={cls.skeletonHeader} />
    ) : (
        <h1 className={cls.projectName}>{projectName}</h1>
    );
};
